import React from 'react';
import success from '../images/success.png';
import '../styles/trade/successpage.css';

export default function Successful() {

    const handleHome = e => {
        window.location.replace('../');
    }
    const handleFaq = e => {
        window.location.replace('../#faqs');
    }
    const handleTerms = e => {
        window.location.replace('../terms');
    }

    return (
        <div style={{background:'black', height: '100vh'}}>
        <div style={{background:'blue', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', padding:'auto', float:'center', height:'90vh'}}> 
            <h1 style={{color:'white'}}>ORDER SUCCESSFUL</h1>
            <p><img className='success-img' src={success} style={{width:'150px', height:'150px', background:'white', borderRadius:'50%'}}/></p>
            <p style={{color:'gold'}}>...processing time : 5mins</p><br /><br />

            <p><a href='https://wa.me/2348162624366?text=Hello%20I' target='_blank' style={{color:'white'}}>customer support live chat</a></p>



            </div>



            <div style={{display: 'flex', justifyContent:'center', marginTop:'5px', color : 'white', fontSize : '12px', background:'black'}}> <span onClick={handleHome}><a style={{color : 'white', cursor:'pointer'}}>Home</a> </span > <span style={{marginLeft: '10px'}} onClick={handleFaq}> <a style={{color : 'white', cursor:'pointer'}}>FAQs</a> </span> <span style={{marginLeft: '10px'}} onClick={handleTerms}> <a style={{color : 'white', cursor:'pointer'}}>Terms of Service</a></span></div> <br />
             <p style={{ dislay:'flex',justifyContent:'center', textAlign:'center', color:'white', fontSize:'10px'}}> ⓒ Vhions Exchange 2021</p>
            
        </div>  
    )
};